<template>
  <div class="material-sample">
    <div class="sample-sign-cover">
      <img class="sample-sign" src="../../assets/imgs/upload/sample.png">
    </div>
    <img class="sample-img" :src="sampleUrl">
  </div>
</template>

<script>
export default {
  name: 'material-sample',
  props: {
    sampleUrl: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/less/variable';
.material-sample {
  height: 160px;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  .sample-sign-cover {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255,255,255,.2);
    .sample-sign {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .sample-img {
    max-height: 100%;
    max-width: 300px;
    border: 1px solid @border;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload/sample.vue